import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Signin from '../views/Signin.vue'
import DeviceList from '../views/Devices/List.vue'
import DeviceForm from '../views/Devices/Form.vue'
import CompanyList from '../views/Companies/List.vue'
import CompanyForm from '../views/Companies/Form.vue'
import UserList from '../views/Users/List.vue'
import UserForm from '../views/Users/Form.vue'
import TagList from '../views/Tags/List.vue'
import TagForm from '../views/Tags/Form.vue'
// import PacketList from '../views/Packets/List.vue'
import PacketDetails from '../views/PacketDetails/List.vue'
import PacketErrorList from '../views/ErrorLogs/List.vue'
import DayList from '../views/Days/List.vue'
import FirmwareForm from '../views/Firmwares/Form.vue'
import FirmwareList from '../views/Firmwares/List.vue'
import Date from '../views/Date.vue'
import Fota from '../views/Firmwares/Fota.vue'
import Monitor from '../views/Devices/Monitor.vue'
import Monitor4051 from '../views/Devices/Monitor4051.vue'
import Monitor6623 from '../views/Devices/Monitor6623.vue'
import Monitor6626 from '../views/Devices/Monitor6626.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/devices'
  },
  {
    path: '/date',
    name: 'date',
    meta: {
      title: 'date'
    },
    component: Date
  },
  {
    path: '/signin',
    name: 'Signin',
    meta: {
      layout: 'no-app-bar'
    },
    component: Signin
  },
  {
    path: '/packets',
    name: 'PacketList',
    meta: {
      title: '패킷 조회'
    },
    component: PacketDetails,
    beforeEnter: checkAuth
  },
  {
    path: '/firmwares',
    name: 'FirmwareList',
    meta: {
      title: '펌웨어 관리'
    },
    component: FirmwareList,
    beforeEnter: checkAuth
  },
  {
    path: '/firmwares/new',
    name: 'AddFirmware',
    meta: {
      title: '펌웨어 등록'
    },
    component: FirmwareForm,
    beforeEnter: checkAuth
  },
  {
    path: '/firmwares/:id/edit',
    name: 'EditFirmware',
    props: { edit: true },
    meta: {
      title: '펌웨어 수정'
    },
    component: FirmwareForm,
    beforeEnter: checkAuth
  },
  {
    path: '/firmwares/:id/fota',
    name: 'FotaFirmware',
    meta: {
      title: '포타 요청'
    },
    component: Fota,
    beforeEnter: checkAuth
  },
  {
    path: '/errors',
    name: 'PacketErrorList',
    meta: {
      title: '에러 조회'
    },
    component: PacketErrorList,
    beforeEnter: checkAuth
  },
  {
    path: '/tags',
    name: 'TagList',
    meta: {
      title: '태그 관리'
    },
    component: TagList,
    beforeEnter: checkAuth
  },
  {
    path: '/days',
    name: 'DayList',
    meta: {
      title: '운행 기록'
    },
    component: DayList,
    beforeEnter: checkAuth
  },
  {
    path: '/tags/new',
    name: 'AddTag',
    meta: {
      title: '태그 추가'
    },
    component: TagForm,
    beforeEnter: checkAuth
  },
  {
    path: '/tags/:id/edit',
    name: 'EditTag',
    meta: {
      title: '태그 편집'
    },
    component: TagForm,
    props: { edit: true },
    beforeEnter: checkAuth
  },
  {
    path: '/devices',
    name: 'DeviceList',
    meta: {
      title: '장치 관리'
    },
    component: DeviceList,
    beforeEnter: checkAuth
  },
  {
    path: '/devices/:id/edit',
    name: 'EditDevice',
    meta: {
      title: '장치 편집'
    },
    component: DeviceForm,
    beforeEnter: checkAuth
  },
  {
    path: '/devices/1229874051/monitor',
    name: 'MonitorDevice4051',
    props: true,
    meta: {
      title: '장치 모니터링'
    },
    component: Monitor4051,
    beforeEnter: checkAuth
  },
  {
    path: '/devices/1223286623/monitor',
    name: 'MonitorDevice6623',
    props: true,
    meta: {
      title: '장치 모니터링'
    },
    component: Monitor6623,
    beforeEnter: checkAuth
  },
  {
    path: '/devices/1223286626/monitor',
    name: 'MonitorDevice6626',
    props: true,
    meta: {
      title: '장치 모니터링'
    },
    component: Monitor6626,
    beforeEnter: checkAuth
  },
  {
    path: '/devices/:identityNo/monitor',
    name: 'MonitorDevice',
    props: true,
    meta: {
      title: '장치 모니터링'
    },
    component: Monitor,
    beforeEnter: checkAuth
  },
  {
    path: '/companies',
    name: 'CompanyList',
    meta: {
      title: '회사 관리'
    },
    component: CompanyList,
    beforeEnter: checkAuth
  },
  {
    path: '/users',
    name: 'UserList',
    meta: {
      title: '사용자 관리'
    },
    component: UserList,
    beforeEnter: checkAuth
  },
  {
    path: '/users/new',
    name: 'AddUser',
    meta: {
      title: '사용자 추가'
    },
    component: UserForm,
    beforeEnter: checkAuth
  },
  {
    path: '/users/:id/edit',
    name: 'EditUser',
    meta: {
      title: '사용자 편집'
    },
    component: UserForm,
    props: { edit: true },
    beforeEnter: checkAuth
  },
  {
    path: '/companies/new',
    name: 'AddCompany',
    meta: {
      title: '회사 추가'
    },
    component: CompanyForm,
    beforeEnter: checkAuth
  },
  {
    path: '/companies/:id/edit',
    name: 'EditCompany',
    meta: {
      title: '회사 편집'
    },
    component: CompanyForm,
    props: { edit: true },
    beforeEnter: checkAuth
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function checkAuth (to, from, next) {
  if (!store.state.user.isLoggedIn) next('/signin')
  else next()
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach(() => {
  store.commit('setLoading', false)
})

export default router
